/**
 * Gets the font size based on the size of the avatar
 *
 * @param size number
 * @returns number
 */
export const getFontSize = (size) => {
    /**
     * Based on linear regression over these samples:
     * size: 100 -> fontSize: 36
     * size: 60  -> fontSize: 24
     * size: 40  -> fontSize: 16
     * size: 20  -> fontSize: 8
     */
    const fontSize = 0.349 * size + 1.83;
    return Math.round(fontSize);
};
